import Loading from 'vue-loading-overlay';
import { AcesService } from "../../../api/AcesService";
import { StoreProxy } from "../../../api/common/StoreProxy";


export default {
    name: "AcesUpload",
    _service: null,
    data() {
        return {
            isSelectingFile: true,
            isShowingStatus: false,
            isUploading: false,
            isUploadingFailed: false,       
            uploadResult: null,
            file: undefined,
            fileName: "",
            uploadFailedReason: "Unknown",
            service: undefined
        }
    },
    validations: {
    },
    components: {
        Loading
    },
    created() {
         
    },
    mounted() {        
        
    },
    methods: {
        clearStateFlags() {
            this.isSelectingFile = true;
            this.isUploading = false;
            this.isUploadingFailed = false;
        },
        onSubmit() {
            const service = new AcesService(StoreProxy.getAuth(this.$store));
            this.isUploading = true;
            service.uploadAces(this.file)
                .then(result => {
                    this.uploadResult = result;
                    this.isUploading = false;
                })
                .catch(ex => {
                    debugger;
                    this.clearStateFlags();
                    this.isUploadingFailed = true;
                    if (ex && ex.message) {
                        this.uploadFailedReason = ex.message;
                    } else {
                        this.uploadFailedReason = "Unknown";
                    }
                });
        },
        triggerFileInput(event) {
            this.$refs.fileInput.click();
            event.preventDefault();
        },
        handleFileChange(event) {
            const selectedFile = event.target.files[0];
            if (selectedFile) {
                this.file = selectedFile;
                this.fileName = selectedFile.name;
            }
        },
        handleUpload() {
            this.$refs.upload.submit(); // Manually trigger the upload process
        }
    },
    onCancel() {
        this.$router.back();
    },
    onSubmit() {
    }
}